import { render } from "./DebugModal.vue?vue&type=template&id=68637536"
const script = {}

import "./DebugModal.vue?vue&type=style&index=0&id=68637536&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__